import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { rel } from '../../../../../../utils/rel';

class Subject extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.list}>
                <h3>专题策划</h3>
                {content[0].img ? (
                    <div className={styles.img}>
                        <a href={content[0] ? content[0].url : ''} target="_blank" rel={rel}>
                            <img src={content[0] ? content[0].img : ''} />
                        </a>
                    </div>
                ) : (
                    ''
                )}
                <ul>
                    {content.map((item, index) => (
                        <li key={index}>
                            <a href={item.url} target="_blank" rel={rel}>
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(Subject);
